interface IProps {
  color: string;
  width: string;
  height: string;
}

const LogoutWidget = ({color, width, height}: IProps) => {
  return <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width={width} height={height} viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet">
 
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color} stroke="none">
        <path d="M1765 4674 c-171 -42 -336 -175 -414 -334 -66 -135 -71 -174 -71
        -590 0 -229 4 -379 11 -404 15 -54 83 -119 142 -135 95 -27 195 13 244 97 l28
        47 5 385 c4 333 7 389 22 415 20 37 52 67 98 91 33 18 83 19 1125 22 803 2
        1104 0 1144 -8 71 -16 142 -83 159 -152 17 -67 17 -3029 0 -3096 -17 -69 -88
        -136 -159 -152 -40 -8 -341 -10 -1144 -8 -1042 3 -1092 4 -1125 22 -46 24 -78
        54 -98 91 -15 26 -18 82 -22 416 l-5 386 -30 48 c-44 71 -118 109 -198 102
        -70 -6 -125 -39 -164 -99 l-28 -42 -3 -381 c-3 -438 1 -476 69 -615 56 -114
        169 -228 279 -282 146 -72 77 -69 1382 -66 l1173 3 65 22 c188 65 333 207 409
        401 l26 67 0 1635 0 1635 -26 67 c-74 191 -206 323 -397 397 l-67 26 -1185 2
        c-1008 1 -1194 -1 -1245 -13z"/>
        <path d="M2045 3181 c-74 -34 -125 -111 -125 -187 0 -63 22 -115 73 -170 l49
        -54 -729 0 -730 0 -44 -23 c-24 -13 -57 -43 -74 -66 -27 -39 -30 -50 -30 -120
        0 -68 3 -82 27 -117 15 -21 44 -50 65 -64 l37 -25 739 -3 739 -2 -49 -54 c-73
        -79 -92 -169 -54 -251 34 -74 111 -125 187 -125 92 0 105 10 362 264 153 152
        250 256 262 281 26 54 26 136 0 190 -12 25 -109 129 -262 281 -201 198 -250
        242 -284 252 -59 17 -113 14 -159 -7z"/>
      </g>
    </svg>
}

export default LogoutWidget;